module.exports = __webpack_public_path__ + "static/media/iconComision.a51d9abc.svg";